<form [formGroup]="formName">
    <mat-form-field appearance="fill" class="form-activities" style="width: 100%;">
        <mat-label>{{field.label}} : </mat-label>
        <input matInput [type]="field.type" [formControlName]="field.fieldName" />
    </mat-form-field>
</form>